import { haveAnyValue } from 'src/utils/utilitiesV2'

const isNecessaryAddressComponents = (address: string): boolean => {
  return haveAnyValue(address) && address.trim().toLowerCase() !== 'ciudad'
}

export { isNecessaryAddressComponents }
